/**
 * APY hooks
 */

export { useAdvertisedApy, type UseAdvertisedApyResult } from "./useAdvertisedApy";
